//
// TODO: explain what this `coordinates` object is and what each
//       attribute value means.
//

define(function(require) {
    'use strict';

    var coordinates = {
        'up-left': [-1, -2],
        'up-center': [0, -2],
        'up-right': [1, -2],
        'down-left': [-1, 2],
        'down-center': [0, 2],
        'down-right': [1, 2],
        'up-fluid': [0, -60],
        'down-fluid': [0, 30],
    };

    var getOrderedLocations = function(preference) {
        var locations = {};

        Object.keys(coordinates).forEach(function(prop) {
            var parts = prop.split('-');
            locations[prop] = {
                name: prop,
                direction: parts[0],
                alignment: parts[1],
                coordinate: coordinates[prop],
            };
        });

        var getDistanceSquared = function(locationA, locationB) {
            // Distance squared is ok for sorting.
            return (
                Math.pow(locationA.coordinate[0] - locationB.coordinate[0], 2) +
                Math.pow(locationA.coordinate[1] - locationB.coordinate[1], 2)
            );
        };

        var orderedKeys = Object.keys(locations).sort(function(a, b) {
            return (
                getDistanceSquared(locations[a], locations[preference]) -
                getDistanceSquared(locations[b], locations[preference])
            );
        });

        return orderedKeys.map(function(key) {
            return locations[key];
        });
    };

    var isRectOutOfBounds = function(rect, bounds) {
        var offset = bounds.offset || 0;
        var offsetTop = offset + rect.top;
        var offsetBottom = offset + rect.top + rect.height;

        return (
            rect.left + rect.width > bounds.width ||
            offsetBottom > bounds.height ||
            rect.left < 0 ||
            offsetTop < 0
        );
    };

    //
    // Create a new rectangle for content based on a bunch of things.
    //
    var createBox = function(originRect, contentRect, location, spacing) {
        var box = {
            location: location.name,
            alignment: location.alignment,
            width: contentRect.width,
            height: contentRect.height,
        };

        switch (location.direction) {
            case 'up':
                box.top = originRect.top - contentRect.height - spacing;
                break;
            case 'down':
                box.top = originRect.top + originRect.height + spacing;
                break;
        }

        if (location.alignment !== 'fluid') {
            switch (location.alignment) {
                case 'left':
                    box.left = originRect.left;
                    break;
                case 'center':
                    box.left = originRect.left + originRect.width / 2 - contentRect.width / 2;
                    break;
                case 'right':
                    box.left = originRect.left + originRect.width - contentRect.width;
                    break;
            }
        }

        return box;
    };

    return {
        getOrderedLocations: getOrderedLocations,
        isRectOutOfBounds: isRectOutOfBounds,
        createBox: createBox,
    };
});



// WEBPACK FOOTER //
// ./~/@99designs/asimov/detached-dropdown/lib/position-utils.js